/* tslint:disable */
/* eslint-disable */
export enum Language {
  English = 'ENGLISH',
  Arabic = 'ARABIC',
}
